"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
var React = require("react");
var Email = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { d: "M19,5 C19.6,5 20,5.4 20,6 L20,7.5 L12,11.9 L4,7.4 L4,6 C4,5.4 4.4,5 5,5 L19,5 Z M11.5,13.9 C11.78,14.04 12.22,14.04 12.5,13.9 L20,9.7 L20,18 C20,18.6 19.6,19 19,19 L5,19 C4.4,19 4,18.6 4,18 L4,9.7 L11.5,13.9 Z", id: "EMAIL-SVG-ICON-PATH1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "EMAIL-SVG-ICON-mask-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#EMAIL-SVG-ICON-PATH1" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#EMAIL-SVG-ICON-mask-2)", fill: "#00242D" },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Email = Email;
//# sourceMappingURL=Email.js.map